<template>
    <div class="profile-creation-wizard__side">
        <div class="profile-creation-wizard__side-desktop"></div>
    </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss"></style>
